import { Button, FormControl, FormLabel, Input, Modal, ModalClose, ModalDialog, Option, Select, Stack, Typography } from "@mui/joy";
import { useContext, useEffect, useState } from "react";
import { LayoutContext } from "../../context";
import { APIGetAdditionalService, APICreateEventAdditionalService } from "../../api";

// Модалка «Добавить доп» для чертёжника: услуга из каталога + значение для
// услуг «по вводу». Автора/роль проставляет сервер по токену — здесь не шлём.
export default function ModalDraftsmanAddService({ open, onClose, eventId, onAdded }) {
  const { notify } = useContext(LayoutContext);
  const [catalog, setCatalog] = useState([]);
  const [loadingCatalog, setLoadingCatalog] = useState(false);
  const [serviceId, setServiceId] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setServiceId(null);
    setInputValue("");
    (async () => {
      setLoadingCatalog(true);
      try {
        const data = await APIGetAdditionalService();
        setCatalog(Array.isArray(data) ? data : (data?.results || []));
      } catch (e) {
        console.error("Ошибка загрузки каталога допов:", e);
      } finally {
        setLoadingCatalog(false);
      }
    })();
  }, [open]);

  const selected = catalog.find((s) => s.id === serviceId) || null;
  const isPerInput = selected?.calculation_type === "per_input";

  const handleAdd = async () => {
    if (!serviceId) { notify?.("Выберите услугу", "warning"); return; }
    if (isPerInput && (!inputValue || Number(inputValue) <= 0)) {
      notify?.("Заполните значение", "warning"); return;
    }
    setSaving(true);
    try {
      const payload = { event: eventId, additional_service: serviceId };
      if (isPerInput) payload.input_value = Number(inputValue);
      const res = await APICreateEventAdditionalService(payload);
      if (res?.status === "ok") {
        notify?.("Доп добавлен", "success");
        onAdded?.(res.service_item);
        onClose?.();
      } else {
        notify?.(res?.message || res?.response?.data?.message || "Не удалось добавить доп", "danger");
      }
    } catch (e) {
      console.error("Ошибка добавления допа:", e);
      notify?.("Ошибка при добавлении допа", "danger");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={!!open} onClose={onClose}>
      <ModalDialog sx={{ minWidth: 320, maxWidth: 440 }}>
        <ModalClose />
        <Typography level="title-lg" sx={{ mb: 1 }}>Добавить доп. услугу</Typography>
        <Stack spacing={1.5}>
          <FormControl>
            <FormLabel>Услуга</FormLabel>
            <Select
              placeholder={loadingCatalog ? "Загрузка…" : "Выберите услугу"}
              value={serviceId}
              onChange={(e, v) => setServiceId(v)}
            >
              {catalog.map((s) => (
                <Option key={s.id} value={s.id}>{s.title}</Option>
              ))}
            </Select>
          </FormControl>

          {isPerInput && (
            <FormControl>
              <FormLabel>
                {selected?.input_label || "Значение"}{selected?.input_unit ? ` (${selected.input_unit})` : ""}
              </FormLabel>
              <Input type="number" value={inputValue} onChange={(e) => setInputValue(e.target.value)} placeholder="0" />
            </FormControl>
          )}

          <Button loading={saving} disabled={!serviceId} onClick={handleAdd}>Добавить</Button>
        </Stack>
      </ModalDialog>
    </Modal>
  );
}